module.exports = __webpack_public_path__ + "img/interests-color.7be4df79.svg";